import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getAllRenterProperties = (): Promise<ISelectModel<string>[]> => {
  return API.get('/api/renter/accommodation/properties/all').then(response => response?.data);
};
